import './style/index.js';

import _TagInput from './TagInput';

export type { TagInputProps } from './TagInput';
export * from './type';

export const TagInput = _TagInput;
export default TagInput;
